import { useState } from "react";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import { ListarFormulariosController } from "../../../../Controllers/Geral/Formularios/FormulariosControllers";
import { EnviarFormularioEmailController } from "../../../../Controllers/Geral/GestaoClientes/GestaoClientesController";
import { GetTemplatesController } from "../../../../Controllers/Geral/TemplatesModulo/TemplatesModuloControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { ITemplatesModuloInterface } from "../../../../Interfaces/Geral/TemplatesModulo/TemplatesModuloInterface";
interface IModalEnviarFormularioProps {
    idConta: number;
    idProduto: number;
}

export default function ModalEnviarFormulario(
    props: IModalEnviarFormularioProps
) {
    const [idDocumentoTemplate, setIdDocumentoTemplate] = useState(0);
    const [templateValues, setTemplateValues] = useState<ITemplatesModuloInterface[]>([]);


    const { value: lstFormularios, loading: lstFormulariosLoading } =
        useAsyncEffect(async () => {
            return ListarFormulariosController();
        }, []);

    const { execute, loading } = useAsyncCallback(
        EnviarFormularioEmailController
    );
    
    const getTemplatesValues = async () => {
        try {
            const tValues = await GetTemplatesController();
            setTemplateValues(tValues);
            console.log("templateValues", templateValues);
        } catch (error) {
            console.error("Ocorreu um erro ao obter os valores do template:", error);
        }
    }
    
    useAsyncEffect(async () => {
        getTemplatesValues();
    }, []);
    
    
    return (
        <OrSpinner loading={lstFormulariosLoading} spinner={"capys"}>
            {lstFormularios?.map((formulario) => (
                <>
                    <div
                        key={formulario.ID_PRODUTO}
                        className="d-flex justify-content-between align-items-center "
                    >
                        <div>
                            <h3>Formulário: {formulario.DS_FORMULARIO}</h3>
                            {formulario.DS_INFORMACOES && (
                                <span>
                                    Descrição: {formulario.DS_INFORMACOES}
                                </span>
                            )}

                            <p className="mt-5 col-12 p-0">
                                <span>
                                    <h6>
                                        Selecione um Documento Template para o
                                        envio:
                                    </h6>

                                    <select
                                        className="col-8 rounded"
                                        onChange={(event) => {
                                            setIdDocumentoTemplate(Number(event.target.value));
                                        }}
                                        defaultValue={0}
                                    >
                                        <option value="0"></option>
                                        {templateValues.map((value) => (
                                            <option key={value.ID_DOCUMENTO_TEMPLATE} value={value.ID_DOCUMENTO_TEMPLATE}>
                                                {value.DS_DOCUMENTO}
                                            </option>
                                        ))}
                                    </select>

                                </span>
                            </p>
                        </div>

                        <div className="d-flex justify-content-center align-items-center">
                            <button
                                style={{ maxHeight: 40, maxWidth: 80 }}
                                className="btn btn-outline-primary mw-80 mh-40 ml-5"
                                disabled={loading || !idDocumentoTemplate}
                                onClick={() => {
                                    execute(
                                        formulario.ID_FORMULARIO,
                                        props.idConta,
                                        props.idProduto,
                                        idDocumentoTemplate
                                    );
                                }}
                            >
                                Enviar
                            </button>
                        </div>
                    </div>
                    <hr />
                </>
            ))}
        </OrSpinner>
    );
}
